module.exports = __webpack_public_path__ + "img/mobile scanner stand23.7e03ccd8.jpg";